/** Internal link mesh — related posts by slug (SEO + UX). */
export const BLOG_RELATED_SLUGS = {
  'free-cfa-level-1-mock-exam-2026': [
    'cfa-level-1-practice-questions-free',
    'cfa-level-1-mock-exam-how-to-practice',
    'cfa-level-1-exam-dates-2026',
    'how-to-pass-cfa-level-1-study-plan',
  ],
  'cfa-level-1-practice-questions-free': [
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-1-exam-format-topic-weights-2026',
    'cfa-level-1-mock-exam-how-to-practice',
    'cfa-level-1-formulas-2026',
  ],
  'how-to-pass-cfa-level-1-study-plan': [
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-1-exam-dates-2026',
    'cfa-level-1-last-month-study-plan',
    'cfa-level-1-february-2027-deadlines-fees',
  ],
  'cfa-level-1-pass-rate-2026': [
    'free-cfa-level-1-mock-exam-2026',
    'how-to-pass-cfa-level-1-study-plan',
    'cfa-level-1-february-2027-deadlines-fees',
    'cfa-level-1-results-release-timeline',
  ],
  'cfa-level-1-exam-dates-2026': [
    'cfa-level-1-february-2027-deadlines-fees',
    'cfa-level-1-practice-questions-free',
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-2-exam-dates-2026',
  ],
  'cfa-level-1-february-2027-deadlines-fees': [
    'cfa-level-1-practice-questions-free',
    'how-to-pass-cfa-level-1-study-plan',
    'cfa-level-1-exam-dates-2026',
    'free-cfa-level-1-mock-exam-2026',
  ],
  'cfa-level-1-formulas-2026': [
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-1-quantitative-methods-tvm',
    'cfa-level-1-calculator-ba-ii-plus',
    'cfa-level-1-exam-dates-2026',
  ],
  'cfa-level-1-exam-format-topic-weights-2026': [
    'free-cfa-level-1-mock-exam-2026',
    'how-to-pass-cfa-level-1-study-plan',
    'cfa-level-1-exam-dates-2026',
    'cfa-level-1-practice-questions-free',
  ],
  'cfa-level-1-ethics-study-guide': [
    'cfa-level-1-practice-questions-free',
    'how-to-pass-cfa-level-1-study-plan',
    'cfa-level-1-exam-format-topic-weights-2026',
    'cfa-level-1-mock-exam-how-to-practice',
  ],
  'cfa-level-1-calculator-ba-ii-plus': [
    'cfa-level-1-quantitative-methods-tvm',
    'cfa-level-1-formulas-2026',
    'cfa-level-1-financial-statement-analysis-tips',
    'cfa-level-1-practice-questions-free',
  ],
  'cfa-level-1-mock-exam-how-to-practice': [
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-1-practice-questions-free',
    'cfa-level-1-pass-rate-2026',
    'how-to-pass-cfa-level-1-study-plan',
  ],
  'cfa-level-1-financial-statement-analysis-tips': [
    'cfa-level-1-formulas-2026',
    'cfa-level-1-exam-format-topic-weights-2026',
    'cfa-level-1-calculator-ba-ii-plus',
    'cfa-level-1-practice-questions-free',
  ],
  'cfa-level-1-fixed-income-duration-guide': [
    'cfa-level-1-formulas-2026',
    'cfa-level-1-calculator-ba-ii-plus',
    'cfa-level-1-derivatives-study-guide',
    'cfa-level-1-practice-questions-free',
  ],
  'cfa-level-1-quantitative-methods-tvm': [
    'cfa-level-1-calculator-ba-ii-plus',
    'cfa-level-1-formulas-2026',
    'cfa-level-1-financial-statement-analysis-tips',
    'how-to-pass-cfa-level-1-study-plan',
  ],
  'cfa-level-1-results-release-timeline': [
    'cfa-level-1-pass-rate-2026',
    'cfa-level-1-exam-dates-2026',
    'cfa-level-1-february-2027-deadlines-fees',
    'free-cfa-level-1-mock-exam-2026',
  ],
  'cfa-level-1-alternative-investments-guide': [
    'cfa-level-1-exam-format-topic-weights-2026',
    'cfa-level-1-portfolio-management-capm',
    'cfa-level-1-practice-questions-free',
    'how-to-pass-cfa-level-1-study-plan',
  ],
  'cfa-level-1-derivatives-study-guide': [
    'cfa-level-1-formulas-2026',
    'cfa-level-1-fixed-income-duration-guide',
    'cfa-level-1-portfolio-management-capm',
    'cfa-level-1-quantitative-methods-tvm',
  ],
  'cfa-level-1-portfolio-management-capm': [
    'cfa-level-1-formulas-2026',
    'cfa-level-1-ethics-study-guide',
    'cfa-level-1-alternative-investments-guide',
    'how-to-pass-cfa-level-1-study-plan',
  ],
  'cfa-level-1-last-month-study-plan': [
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-1-exam-dates-2026',
    'cfa-level-1-mock-exam-how-to-practice',
    'cfa-level-1-formulas-2026',
  ],
  'cfa-level-1-vs-level-2-difference': [
    'cfa-level-2-mock-exam-2026',
    'cfa-level-2-item-sets-explained',
    'cfa-level-2-exam-format-2026',
    'how-to-pass-cfa-level-2-study-plan',
  ],
  'cfa-level-2-mock-exam-2026': [
    'cfa-level-2-item-sets-explained',
    'cfa-level-2-topic-weights-2026',
    'how-to-pass-cfa-level-2-study-plan',
    'cfa-level-2-exam-format-2026',
  ],
  'cfa-level-2-item-sets-explained': [
    'cfa-level-2-mock-exam-2026',
    'cfa-level-2-exam-format-2026',
    'how-to-pass-cfa-level-2-study-plan',
    'cfa-level-1-vs-level-2-difference',
  ],
  'cfa-level-2-topic-weights-2026': [
    'cfa-level-2-mock-exam-2026',
    'how-to-pass-cfa-level-2-study-plan',
    'cfa-level-2-item-sets-explained',
    'cfa-level-2-exam-format-2026',
  ],
  'how-to-pass-cfa-level-2-study-plan': [
    'cfa-level-2-mock-exam-2026',
    'cfa-level-2-topic-weights-2026',
    'cfa-level-2-item-sets-explained',
    'cfa-level-1-vs-level-2-difference',
  ],
  'cfa-level-2-exam-format-2026': [
    'cfa-level-2-mock-exam-2026',
    'cfa-level-2-exam-dates-2026',
    'cfa-level-2-item-sets-explained',
    'cfa-level-2-topic-weights-2026',
  ],
  'cfa-level-2-exam-dates-2026': [
    'cfa-level-2-mock-exam-2026',
    'cfa-level-2-exam-format-2026',
    'cfa-level-1-exam-dates-2026',
    'how-to-pass-cfa-level-2-study-plan',
  ],
  'cfa-level-3-mock-exam-2026': [
    'cfa-level-3-exam-format-2026',
    'cfa-level-3-exam-dates-2026',
    'cfa-level-3-constructed-response-guide',
    'how-to-pass-cfa-level-3-study-plan',
  ],
  'cfa-level-3-exam-format-2026': [
    'cfa-level-3-mock-exam-2026',
    'cfa-level-3-exam-dates-2026',
    'cfa-level-3-constructed-response-guide',
    'cfa-level-2-vs-level-3-difference',
  ],
  'cfa-level-3-exam-dates-2026': [
    'cfa-level-3-mock-exam-2026',
    'cfa-level-3-exam-format-2026',
    'cfa-level-1-exam-dates-2026',
    'how-to-pass-cfa-level-3-study-plan',
  ],
  'cfa-level-3-constructed-response-guide': [
    'cfa-level-3-mock-exam-2026',
    'cfa-level-3-exam-format-2026',
    'how-to-pass-cfa-level-3-study-plan',
    'cfa-level-3-topic-weights-2026',
  ],
  'cfa-level-3-topic-weights-2026': [
    'cfa-level-3-mock-exam-2026',
    'how-to-pass-cfa-level-3-study-plan',
    'cfa-level-3-exam-format-2026',
    'cfa-level-2-topic-weights-2026',
  ],
  'how-to-pass-cfa-level-3-study-plan': [
    'cfa-level-3-mock-exam-2026',
    'cfa-level-3-constructed-response-guide',
    'cfa-level-3-topic-weights-2026',
    'cfa-level-2-vs-level-3-difference',
  ],
  'cfa-level-2-vs-level-3-difference': [
    'cfa-level-3-mock-exam-2026',
    'cfa-level-2-mock-exam-2026',
    'cfa-level-3-exam-format-2026',
    'cfa-level-1-vs-level-2-difference',
  ],
  'cfa-all-levels-lifetime-package-349': [
    'free-cfa-level-1-mock-exam-2026',
    'cfa-level-2-mock-exam-2026',
    'cfa-level-3-mock-exam-2026',
    'cfa-level-1-february-2027-deadlines-fees',
  ],
};

/** Featured on home page — highest search intent. */
export const BLOG_FEATURED_SLUGS = [
  'free-cfa-level-1-mock-exam-2026',
  'cfa-level-1-practice-questions-free',
  'cfa-level-1-february-2027-deadlines-fees',
  'cfa-level-2-mock-exam-2026',
  'cfa-level-3-mock-exam-2026',
  'cfa-all-levels-lifetime-package-349',
  'cfa-level-3-constructed-response-guide',
  'cfa-level-1-exam-dates-2026',
];
